/*
 * Copyright © 2021-present Protonbase Inc. All rights reserved.
 * The information contained in this software is confidential and proprietary to Protonbase Inc. and its subsidiaries. No part of this software may be used, copied, reproduced, modified, displayed, performed, executed, published, distributed, conveyed, stored, transmitted, or otherwise exploited in any form or by any means, including but not limited to electronic, mechanical, photocopying, recording, transcribing, without the prior written consent of Protonbase Inc.
 * Any violation of the above terms will constitute an infringement of copyright and will be subjected to legal action.
 */
import { App, Button } from 'antd'
import { useTranslation } from 'react-i18next'
import { ContractPaymentMethods } from '@/pages/contract/ContractPaymentMethods'
import { RouteSupplyData } from '@/routes/RouteSupplyData'

export function RechargeRemittance() {
  const { t } = useTranslation()
  const { modal } = App.useApp()
  const contract = RouteSupplyData.useContext('contractId').data

  const onClick = () => {
    modal.info({
      icon: null,
      title: t('Recharge Remittance Progress'),
      width: 800,
      maskClosable: true,
      content: <ContractPaymentMethods contract={contract} />,
    })
  }

  return (
    <Button onClick={onClick} type="primary" size="small">
      {t('Recharge Remittance')}
    </Button>
  )
}
